module.exports = __webpack_public_path__ + "img/w_instagram.2f370390.svg";